import img1 from "../assets/img/Gruppe1.webp";

function Home() {
  return <div className="main-wrapper">
    
    <h1>Herzlich willkommen zu freiem, kreativem und wohltuendem Tanzen & Bewegen</h1>

    <p>
      Hier finden Sie Gruppen mit Freiem Kreativem Tanz und Heilsamer Bewegung.
    </p>

    <p>
      Bei diesem Angebot handelt es sich nicht um Therapie, auch wenn Elemente aus der Holistischen Tanz- und Bewegungstherapie (HTB) einfließen können. Wenn Sie Einzelbegleitung suchen, gehen Sie bitte auf meine Praxis-Seite: <a href="https://tanztherapie-muenchen.de" target="_blank" rel="noopener noreferrer">Tanztherapie-Muenchen.de</a>.
    </p>

    <div className="center">
      <img className="size50" src={img1}></img>
    </div>

  </div>;
}
export default Home;